import Heading from "../Components/Heading/Heading";
import LiContent from "../Components/LiContent/LiContent";
import Line from "../Components/Line/Line";
import RelatedT from "../Components/RelatedArticles/Related";
import ConvertButton from "../Components/ConvertButton";
import React from "react";
import FAQComponent from "../Components/FAQComponent/FAQComponent";

function KDEFrameworks(){
    const related = [
        {
            href: '/css',
            name: 'CSS',
            side: 'full support',
            text: 'Learn how to detect JXL support and use JXL images within CSS, like for background images.'
        },
        {
            href: '/exiftool',
            name: 'ExifTool',
            side: 'full support',
            text: 'ExifTool is a platform-independent library. Learn how to read JXL images within ExifTool.'
        }, {
            href: '/exiv2',
            name: 'Exiv2',
            side: 'full support',
            text: 'Exiv2 is a C++ library and utility to read and write image metadata. Learn how to read JXL images within Exiv2.'
        }, {
            href: '/html', name: 'HTML', side: 'full support', text: 'Learn how to use JXL images within HTML.'
        }, {
            href: '/imagemagick',
            name: 'ImageMagick',
            side: 'full support',
            text: 'ImageMagick is an open-source software suite for editing images. Learn how to use JXL images within ImageMagick.'
        }, {
            href: '/kde-frameworks',
            name: 'KDE Frameworks',
            side: 'full support',
            text: 'KDE Frameworks are a set of libraries for programming with Qt. Learn how to use JXL images within KDE.'
        }, {
            href: '/libvips', name: 'libvips', side: 'full support', text: 'Learn how to use JXL images within libvips.'
        }, {
            href: '/php',
            name: 'PHP',
            side: 'partial support',
            text: 'PHP is a widely used scripting language. Learn how to use JXL images within PHP.'
        }, {
            href: '/rust',
            name: 'Rust',
            side: 'full support',
            text: 'Rust is a high-level, general-purpose programming language. Learn how to use JXL images within Rust.'
        }, {
            href: '/squoosh',
            name: 'squoosh',
            side: 'partial support',
            text: 'Squoosh is a free image converter from Google. Learn how to use JXL images with Squoosh.'
        }
    ]
    return (
        <>
            <Heading h='KDE Frameworks JPEG XL support' p='#tutorials'/>
            <article>
                <nav className='content_table'>
                    <h4>Table of Content</h4>
                    <ol className='content_ol'>
                        <LiContent n='1' a='#what-is-kde' text='What is KDE Frameworks?'/>
                        <LiContent n='2' a='#kde-jxl-support' text='KDE Frameworks JXL support'/>
                    </ol>
                </nav>
                <br/>
                <Line/>

                <span id='what-is-kde'>
                    <h1 className="main">What is KDE Frameworks?</h1>
                    <p className='umain'>The KDE Frameworks are add-on libraries that can be used to build applications using Qt. Qt developers will be familiar with the API style of the Frameworks since they have been thoroughly documented and tested. KDE frameworks are developed following a proven KDE governance model with a predictable release schedule, transparent vendor-neutral contributor process, open governance, and flexible LGPL or MIT licenses. Cross-platform frameworks are available for Windows, Mac, Android, and Linux.</p>
                </span>
                <Line/>

                <span id='kde-jxl-support'>
                    <h1 className="main">KDE Frameworks JXL</h1>
                    <p className='umain'>Daniel Novomesky is back again! He created the Plugin qt-jpegxl-image-plugin which allows you to read and write JXL images on Qt and KDE based applications. You will find an easy-to-follow installation guide on the linked Github page.</p>
                </span>
                <Line/>

                <br/><FAQComponent/><br/>
                <RelatedT related={related}/>
            </article>


            <ConvertButton/>
            <br/>
        </>
    )
}

export default KDEFrameworks;